import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  IStudentProfileDetailContainerDispatch,
  IStudentProfileDetailContainerState,
} from "utils/interfaces/student-profile-details";
import AuditTrailModal from "components/AuditTrailModal";
import { AppRoutings } from "utils/enums/app-routings";
import EnrolmentAndAttendanceHistory from "./EnrolmentAndAttendanceHistory";
import StudentDetails from "./StudentDetails";
import ContactNote from "./ContantNote";
import NextOrCurrentSLP from "./NextOrCurrentSLP";
import CompletedSLPList from "./CompletedSLPList";

export type StudentProfileDetailProps = IStudentProfileDetailContainerState &
  IStudentProfileDetailContainerDispatch;

const StudentProfileDetails: React.FC<StudentProfileDetailProps> = (props) => {
  const history = useHistory();

  const {
    studentDetailsRequest,
    enrollmentAndAttendanceHistoryListRequest,
    nextOrCurrentSLPRequest,
    deferSLPRequest,
    plaUserListRequest,
    allocatePLARequest,
    getContactNoteRequest,
    updateSLPContactNoteRequest,
    getAuditTrailListRequest,
    updateSLPParticipationRequest,
    updateSLPContactProgressRequest,
    completedSLPListRequest,
    deleteCompletedSLPRequest,
    updateContactDateRequest,
  } = props;

  const [isAuditTrailModalOpen, setIsAuditTrailModalOpen] =
    useState<boolean>(false);

  return (
    <>
      <div>
        <Box className="content-header simple-header">
          <Typography variant="h2" className="heading">
            Student Profile Details
          </Typography>
          <Box sx={{ display: "flex", columnGap: "14px" }}>
            <Button
              onClick={() => setIsAuditTrailModalOpen(true)}
              variant="outlined"
              className="px-16"
            >
              Audit Logs
            </Button>
            <Button
              variant="outlined"
              className="px-16"
              onClick={() =>
                history.push({
                  pathname: AppRoutings.SLPDashboard,
                })
              }
            >
              Back
            </Button>
          </Box>
        </Box>
        <Grid
          container
          spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
          className="content-container"
        >
          <Grid item xs={12}>
            <StudentDetails
              studentDetailsRequest={studentDetailsRequest}
              updateSLPParticipationRequest={updateSLPParticipationRequest}
            />
          </Grid>
          <Grid item xs={12}>
            <ContactNote
              getContactNoteRequest={getContactNoteRequest}
              editcontactNoteRequest={updateSLPContactNoteRequest}
            />
          </Grid>

          <NextOrCurrentSLP
            nextOrCurrentSLPRequest={nextOrCurrentSLPRequest}
            deferSLPRequest={deferSLPRequest}
            plaUserListRequest={plaUserListRequest}
            allocatePLARequest={allocatePLARequest}
            updateSLPContactProgressRequest={updateSLPContactProgressRequest}
            updateContactDateRequest={updateContactDateRequest}
          />

          <CompletedSLPList
            completedSLPListRequest={completedSLPListRequest}
            deleteCompletedSLPRequest={deleteCompletedSLPRequest}
          />

          <Grid item xs={12}>
            <EnrolmentAndAttendanceHistory
              enrollmentAndAttendanceHistoryListRequest={
                enrollmentAndAttendanceHistoryListRequest
              }
            />
          </Grid>
        </Grid>
      </div>
      {isAuditTrailModalOpen && (
        <AuditTrailModal
          handleAuditTrailModalClose={() => setIsAuditTrailModalOpen(false)}
          isAuditTrailModalOpen={isAuditTrailModalOpen}
          getAuditTrailListRequest={getAuditTrailListRequest}
        />
      )}
    </>
  );
};

export default StudentProfileDetails;
